import styled from 'styled-components';
import colors from '../../../../../styles/colors';

const Container = styled.div`
  margin-bottom: 16px;
  width: ${({ $isHalfWidth }) => ($isHalfWidth ? '50%' : '100%')};
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ $isDarkTheme, $filled }) => {
    if ($isDarkTheme) {
      return $filled ? colors.shades.dark3 : colors.shades.dark5;
    }
    return $filled ? colors.shades.alpha2 : colors.base.alpha;
  }};
  border: 1px solid ${colors.shades.gamma10};
  border-radius: 4px;
  padding: 12px;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${colors.shades.gamma7};
  }

  &:focus-within {
    border-color: ${colors.shades.gamma7};
  }

  ${({ $hasError }) => $hasError && `
    border-color: ${colors.base.danger};
  `}
`;

const InputContent = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label`
  color: ${colors.shades.gamma10};
  font-size: 14px;
  line-height: 1;
  pointer-events: none;
`;

const StyledInput = styled.input`
  flex: 1;
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
  font-size: 16px;
  line-height: 16px;
  padding: 8px 0 4px 0;
  margin-right: ${({ $hasEndAdornment }) => ($hasEndAdornment ? '8px' : '0')};

  &::placeholder {
    color: ${colors.shades.gamma10};
    opacity: 0.7;
  }

  &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:autofill,
      &:autofill:hover,
      &:autofill:focus {
        -webkit-text-fill-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
        caret-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
        transition: 
          background-color 5000s ease-in-out 0s,
          color 5000s ease-in-out 0s,
          -webkit-text-fill-color 5000s ease-in-out 0s;
        background-color: ${({ $isDarkTheme, $filled }) => {
    if ($isDarkTheme) {
      return $filled ? colors.shades.dark3 : colors.shades.dark2;
    }
    return $filled ? colors.shades.alpha2 : colors.base.alpha;
  }}  !important;
      }
`;

const ErrorMessage = styled.div`
  color: ${colors.base.danger};
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 5px;
`;

export {
  Container,
  InputWrapper,
  Label,
  StyledInput,
  ErrorMessage,
  InputContent,
};
